/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Hidden, Typography2 } from '@coursera/cds-core';

import type { NormalizedNotStartedCourse } from '../types/courseStates';

type Props = {
  upcomingCourses: NormalizedNotStartedCourse[];
};

const styles = {
  itemsListContainer: () => css`
    padding: 1rem 0;

    p {
      padding: 0.5rem 0;
    }

    p:not(:first-child) {
      border-top: 1px solid var(--cds-color-grey-50);
    }
  `,
};

const UpcomingCoursesItemsList = ({ upcomingCourses }: Props) => {
  // if only has one upcoming course, no need to render list
  if (upcomingCourses.length < 2) return null;

  return (
    <Hidden xsDown>
      <div css={styles.itemsListContainer} role="list">
        {upcomingCourses.map((course) => (
          <Typography2 component="p" variant="bodyPrimary" id={course.id} role="listitem">
            {course.name}
          </Typography2>
        ))}
      </div>
    </Hidden>
  );
};

export default UpcomingCoursesItemsList;
